import arrayToObject from './arrayToObject';
/**
 * returns an ordered list (onderBy + rest)
 * @param {*} list - [obj1, obj2, obj3, obj4, obj5]
 * @param {*} orderBy  - ['3', '2']
 *
 */

const sortCategoriesList = (list = [], orderBy = []) => {
  if (!orderBy.length || !list.length) {
    return list;
  }

  if (!orderBy.every(i => typeof i === 'string')) {
    throw new Error('Invalid parameter [orderBy]');
  } // easy access to item


  const listObj = arrayToObject(list, 'id');
  const otherIDs = Object.keys(listObj).filter(key => !orderBy.includes(key)); // get ordered list first and the other objs

  const ordered = orderBy.map(item => listObj[item]).slice(0, list.length);
  const rest = otherIDs.map(item => listObj[item]);
  return [...ordered, ...rest];
};

export default sortCategoriesList;